import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import FittersMap from '../components/FittersMap';

class FittersLocator extends Component {

	componentWillMount() {
		const { getFitters } = this.props;
		getFitters();
	}
	
    render(){
    	
    	const { markers, marker, currentMarker, location } = this.props;

		return (
			<div className="row" style={{marginTop: 30}}>
				<div className="col-xs-12">
					<div className="panel-custom-wrapper">
						<div className="panel panel-custom">
							<div className="panel-heading">
								Find a Wright Balance Fitter
							</div>
							<div className="panel-body" style={{height: 600}}>
								<FittersMap currentLocation={location} markers={ markers } selectedMarker={ marker } selectMarker={ currentMarker }/>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect(
	state => {
		const { fitters, markers, marker, location } = state.fittersLocator;

		return {
            fitters, markers, marker, location
		}
	},
	actions
)(FittersLocator)


// WEBPACK FOOTER //
// ./src/fitters-locator/containers/FittersLocator.js